import { gql, useQuery } from '@apollo/client';
import {
  LocationPage_GetPrintPublicationsByUnitQuery,
  LocationPage_GetPrintPublicationsByUnitQueryVariables,
} from '../../../__generated__/queries-topic';
import { PRINT_PUBLICATION_FRAGMENT } from './printPublicationFragment.topic.graphql';

export const GET_PRINT_PUBLICATIONS_BY_UNIT = gql`
  query LocationPage_GetPrintPublicationsByUnit($unitId: UUID!) {
    unit(where: { id: $unitId }) {
      id
      title
      brands(first: 1000) {
        id
        title
        printPublications(first: 1000) {
          ...PrintPublicationFragment
        }
      }
    }
  }
  ${PRINT_PUBLICATION_FRAGMENT}
`;

export const useGetPrintPublicationsByUnit = (
  variables: LocationPage_GetPrintPublicationsByUnitQueryVariables,
) =>
  useQuery<
    LocationPage_GetPrintPublicationsByUnitQuery,
    LocationPage_GetPrintPublicationsByUnitQueryVariables
  >(GET_PRINT_PUBLICATIONS_BY_UNIT, { variables, skip: !variables.unitId });
